import { render, staticRenderFns } from "./ChannelOperator.vue?vue&type=template&id=a4a873b0&scoped=true&"
import script from "./ChannelOperator.vue?vue&type=script&lang=js&"
export * from "./ChannelOperator.vue?vue&type=script&lang=js&"
import style0 from "./ChannelOperator.vue?vue&type=style&index=0&id=a4a873b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a873b0",
  null
  
)

export default component.exports